"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedValueFunctionContext = void 0;
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const rxjs_1 = require("rxjs");
const operators_1 = require("../../operators");
const operators_2 = require("rxjs/operators");
class SharedValueFunctionContext {
    constructor(values) {
        this.values = values;
    }
    get(func) {
        return func(this.values);
    }
    waitFor(func, criteria) {
        return (0, rxjs_1.firstValueFrom)(this.valueChanges(func).pipe((0, operators_1.waitForNext)(criteria)));
    }
    changes(func) {
        return this.valueChanges(func).pipe((0, operators_2.skip)(1)); //Skip the inital value
    }
    valueChanges(func) {
        // Potential performance improvement by recording values used in function and only watching for changes on them.
        return this.values
            .anyChanges()
            .pipe((0, operators_2.map)(() => func(this.values)))
            .pipe((0, operators_2.startWith)(func(this.values)), (0, operators_2.distinctUntilChanged)(lodash_isequal_1.default) // Deep equality check to preserve ref equality when values don't change
        );
    }
}
exports.SharedValueFunctionContext = SharedValueFunctionContext;
//# sourceMappingURL=shared-value-function-context.js.map